export default __webpack_public_path__ + "static/media/frame20x30-black-rotated.ae83acdd.jpg";